mutation DuplicateScoreboard($boardId: ID!) {
  scoreboard: StreamToolsDuplicateScoreboard(boardId: $boardId) {
    boardId
    eventId
    name
    createdAt
    title
    titleTextColor
    dividerColor
    backgroundColor
    backgroundImage
    backgroundImageFit
    cornerRadius
    borderWidth
    borderColor
    fontKey
    version
    competitors {
      competitorId
      boardId
      name
      score
      nameTextColor
      scoreTextColor
      imageUrl
      scoreImageUrl
    }
  }
}
